import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { GC_D0045_INTERSTORE, GC_D2083_IN_APPROVED, GC_D2083_OUT_REJECTED } from "src/app/common/ConstCcd";
import { GC_H0045_INTERSTORE_SLIP_TYPE, GC_H2083_APPL_STATUS_IST } from "src/app/common/ConstCcdDef";
import { TableColumnDef } from "src/app/common/table-column-def";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqGetStoreList } from "src/app/request/req-get-store-list";
import { ReqSpmt10261SlipListSearch } from "src/app/request/req-spmt10261-search";
import { ReqTmt003AllStoreSearch } from "src/app/request/req-tmt003-all-store-search";
import { GetStoreListDto } from "src/app/response/rsp-get-store-list";
import { Spmt10261SlipListDto } from "src/app/response/rsp-spmt10261-search";
import { Tmt003StoreDto } from "src/app/response/rsp-tmt003-all-store-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";

enum ColumnIds {
  SlipNo = "slipNo",
  OutStoreNm = "outStoreNm",
  InStoreNm = "inStoreNm",
  SlipTypeNm = "slipTypeNm",
  OutDate = "outDate",
  InDate = "inDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  SlipCreateDate = "slipCreateDate",
  OutSlipApproveDate = "outSlipApproveDate",
  InSlipApproveDate = "inSlipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  OutRequesterNm = "outRequesterNm",
  OutApproverNm = "outApproverNm",
  InApproverNm = "inApproverNm",
}

enum ColumnHeaders {
  SlipNo = "伝票番号",
  OutStoreNm = "出庫店舗",
  InStoreNm = "入庫店舗",
  SlipTypeNm = "店間移動伝票区分",
  OutDate = "出庫日",
  InDate = "入庫日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  SlipCreateDate = "伝票登録日",
  OutSlipApproveDate = "伝票承認日(出庫)",
  InSlipApproveDate = "伝票承認日(入庫)",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  OutRequesterNm = "出庫申請者",
  OutApproverNm = "出庫承認者",
  InApproverNm = "入庫承認者",
}

class Constant {
  public static readonly ZERO_NUMBER = "0";
  public static readonly IN_STORE_CD_CTRL = "inStoreCd";
  public static readonly SLIP_CREATE_DATE_FROM_CTRL = "slipCreateDateFrom";
  public static readonly SLIP_CREATE_DATE_TO_CTRL = "slipCreateDateTo";
  public static readonly REQ_STATUS_CTRL = "reqStatus";
  public static readonly OUT_REQUESTER_CD_CTRL = "outRequesterCd";
  public static readonly OUT_APPROVER_CD_CTRL = "outApproverCd";
  public static readonly IN_APPROVER_CD_CTRL = "inApproverCd";
  public static readonly OUT_DATE_FROM_CTRL = "outDateFrom";
  public static readonly OUT_DATE_TO_CTRL = "outDateTo";
  public static readonly IN_DATE_FROM_CTRL = "inDateFrom";
  public static readonly IN_DATE_TO_CTRL = "inDateTo";
  public static readonly RED_BLACK_FLG_CTRL = "redBlackFlg";
  public static readonly SLIP_TYPE_CTRL = "slipType";
}

@Component({
  selector: "app-spmt10261-slip-list-dialog",
  templateUrl: "./spmt10261-slip-list-dialog.component.html",
  styleUrls: ["./spmt10261-slip-list-dialog.component.css"],
})
export class Spmt10261SlipListDialogComponent implements OnInit {
  formGroup: FormGroup;
  dataSource = new MatTableDataSource<Spmt10261SlipListDto>();
  recordCount: number = 0;
  tableHeight: number = 239;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  storeSearchConditions: any = {};

  displayedColumns: string[] = [
    ColumnIds.SlipNo,
    ColumnIds.OutStoreNm,
    ColumnIds.InStoreNm,
    ColumnIds.SlipTypeNm,
    ColumnIds.OutDate,
    ColumnIds.InDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.SlipCreateDate,
    ColumnIds.OutSlipApproveDate,
    ColumnIds.InSlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.OutRequesterNm,
    ColumnIds.OutApproverNm,
    ColumnIds.InApproverNm,
  ];
  userList: { userID: string; userName: string }[] = [];
  reqStatusList: KbnSearchDto[] = [];
  slipTypeList: KbnSearchDto[] = [];
  storeList: GetStoreListDto[] = [];
  allStoreList: Tmt003StoreDto[] = [];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutStoreNm, header: ColumnHeaders.OutStoreNm, width: 120, align: Alginment.Left },
    { columnId: ColumnIds.InStoreNm, header: ColumnHeaders.InStoreNm, width: 120, align: Alginment.Left },
    { columnId: ColumnIds.SlipTypeNm, header: ColumnHeaders.SlipTypeNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.OutDate, header: ColumnHeaders.OutDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.InDate, header: ColumnHeaders.InDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 85, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 60, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipApproveDate, header: ColumnHeaders.OutSlipApproveDate, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.InSlipApproveDate, header: ColumnHeaders.InSlipApproveDate, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutRequesterNm, header: ColumnHeaders.OutRequesterNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.OutApproverNm, header: ColumnHeaders.OutApproverNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.InApproverNm, header: ColumnHeaders.InApproverNm, width: 90, align: Alginment.Left },
  ];

  constructor(
    public dialogRef: MatDialogRef<Spmt10261SlipListDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      storeCd: string;
      storeNm: string;
    },
    private readonly fb: FormBuilder,
    public commonService: CommonService,
    private readonly httpBasic: HttpBasicService
  ) {
    this.formGroup = this.fb.group({
      inStoreCd: [EMPTY_STRING],
      slipCreateDateFrom: [new Date()],
      slipCreateDateTo: [new Date()],
      reqStatus: fb.array([]),
      outRequesterCd: [commonService.loginUser.userId],
      outApproverCd: [EMPTY_STRING],
      inApproverCd: [EMPTY_STRING],
      outDateFrom: [EMPTY_STRING],
      outDateTo: [EMPTY_STRING],
      inDateFrom: [EMPTY_STRING],
      inDateTo: [EMPTY_STRING],
      redBlackFlg: [EMPTY_STRING],
      slipType: [GC_D0045_INTERSTORE],
    });
  }

  getKbnList(callBack: () => void) {
    const rcdKbns = [GC_H2083_APPL_STATUS_IST, GC_H0045_INTERSTORE_SLIP_TYPE];
    const request = {
      access: this.data.access,
      rcdKbns,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    return this.httpBasic.tmt050AllKbnSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.reqStatusList = res.rows.filter((row) => row.rcdKbn === GC_H2083_APPL_STATUS_IST);
        this.slipTypeList = res.rows.filter((row) => row.rcdKbn === GC_H0045_INTERSTORE_SLIP_TYPE);
        callBack();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getUserLists() {
    let request: Req = {
      access: this.commonService.loginUser,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.generalRequest("GetUserList", request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.userList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  btnSearchClick() {
    if (!this.formGroup.valid) {
      return;
    }
    this.paginator.pageIndex = 0;
    let reqStatus: string[] = [];
    const reqStatusFormArray = this.formGroup.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      if (reqStatusFormArray.value[i]) {
        reqStatus.push(item.kbn);
      }
    });
    this.storeSearchConditions = {
      outStoreCd: this.data.storeCd,
      inStoreCd: this.formGroup.get(Constant.IN_STORE_CD_CTRL).value,
      slipCreateDateFrom: this.commonService.dateToString(this.formGroup.get(Constant.SLIP_CREATE_DATE_FROM_CTRL).value),
      slipCreateDateTo: this.commonService.dateToString(this.formGroup.get(Constant.SLIP_CREATE_DATE_TO_CTRL).value),
      reqStatus: reqStatus,
      outRequesterCd: this.formGroup.get(Constant.OUT_REQUESTER_CD_CTRL).value,
      outApproverCd: this.formGroup.get(Constant.OUT_APPROVER_CD_CTRL).value,
      inApproverCd: this.formGroup.get(Constant.IN_APPROVER_CD_CTRL).value,
      outDateFrom: this.commonService.dateToString(this.formGroup.get(Constant.OUT_DATE_FROM_CTRL).value),
      outDateTo: this.commonService.dateToString(this.formGroup.get(Constant.OUT_DATE_TO_CTRL).value),
      inDateFrom: this.commonService.dateToString(this.formGroup.get(Constant.IN_DATE_FROM_CTRL).value),
      inDateTo: this.commonService.dateToString(this.formGroup.get(Constant.IN_DATE_TO_CTRL).value),
      redBlackFlg: this.formGroup.get(Constant.RED_BLACK_FLG_CTRL).value,
      slipType: this.formGroup.get(Constant.SLIP_TYPE_CTRL).value,
    };
    this.fnSearch();
  }

  pageChanged() {
    this.fnSearch();
  }

  private fnSearch() {
    const req: ReqSpmt10261SlipListSearch = {
      access: this.data.access,
      ...this.storeSearchConditions,
      pageInfo: { pageNum: this.paginator.pageIndex, dispNum: this.paginator.pageSize },
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10261SlipListSearch(req).subscribe({
      next: (data) => {
        if (this.httpBasic.handleAppError(data)) return;
        this.dataSource.data = data.rows;
        this.recordCount = data.recordCount;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  onRowClick(row: Spmt10261SlipListDto): void {
    let temp = !row.highlightFlg;
    this.dataSource.data.forEach((x) => (x.highlightFlg = false));
    row.highlightFlg = temp;
  }

  btnSelectClick() {
    const hightlightRow = this.dataSource.data.find((x) => x.highlightFlg);
    if (!hightlightRow) {
      return;
    }
    this.dialogRef.close(hightlightRow);
  }

  btnCloseClick() {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.getUserLists();
    this.getStoreList();
    this.getKbnList(() => {
      const reqStatus: FormArray = this.formGroup.get(Constant.REQ_STATUS_CTRL) as FormArray;
      this.reqStatusList.forEach((item) => {
        const isTrue = item.kbn !== GC_D2083_OUT_REJECTED && item.kbn !== GC_D2083_IN_APPROVED;
        reqStatus.push(new FormControl(isTrue));
      });
    });
    this.getAllStoreList()
  }

  private getAllStoreList() {
    let request: ReqTmt003AllStoreSearch = {
      access: this.data.access,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.tmt003AllStoreSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.allStoreList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getStoreList() {
    let request: ReqGetStoreList = {
      access: this.data.access,
      storeCd: EMPTY_STRING,
      userId: EMPTY_STRING,
      cmpyCd: this.data.access.cmpnyCd,
      sysModeCd: this.data.access.sysModeCd,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getStoreList(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.storeList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  isBtnSelectDisabled(): boolean {
    return this.dataSource.data.every((x) => !x.highlightFlg);
  }
}
